import type { RedirectParameters } from "../@api/config";
import { getAndDecodeOption } from "@kivra/sdk/common";
import type { ColorScheme, Config } from "../types";
import { getSearch, isStrongAuthReturn } from "../utils/location";
import {
  getAcrValuesFromSearch,
  getStrongAuthCodeFromSearch,
  getStrongAuthErrorFromSearch,
  getStrongAuthStateFromSearch,
} from "../utils/teliaTunnistus";
import {
  convertUrlParametersFromBase64,
  getRedirectParametersFromSearchWithConfig,
} from "../utils/helpers";

export interface UrlParameters {
  redirectParameters: RedirectParameters;
  isStrongAuthReturn: boolean;
  traceString?: string;
  traceId?: number;
  error?: string;
  code?: string;
  colorScheme?: ColorScheme;
  hideNavigation?: boolean;
  auto_logout?: boolean;
  acr_values?: string;
  termsAccepted?: boolean;
  authContext?: string;
  device?: string;
}

export function getUrlParameters(
  location: Location,
  config: Config,
): UrlParameters {
  const search = getSearch(location);
  if (isStrongAuthReturn(location)) {
    const state = getStrongAuthStateFromSearch(search);
    const paramsFromState = convertUrlParametersFromBase64(state, config);
    const code = getStrongAuthCodeFromSearch(search);
    const error = getStrongAuthErrorFromSearch(search);
    const acr_values = getAcrValuesFromSearch(search);

    return {
      redirectParameters: paramsFromState.redirectParameters,
      isStrongAuthReturn: true,
      code,
      error,
      traceId: paramsFromState.traceId,
      traceString: paramsFromState.traceString,
      colorScheme: paramsFromState.colorScheme,
      hideNavigation: paramsFromState.hideNavigation,
      acr_values,
      termsAccepted: paramsFromState.termsAccepted,
      authContext: paramsFromState.authContext,
      device: paramsFromState.device,
    };
  }

  return {
    redirectParameters: getRedirectParametersFromSearchWithConfig(
      search,
      config,
    ),
    isStrongAuthReturn: false,
    auto_logout: getAndDecodeOption("auto_logout", location.href) === "1",
    hideNavigation:
      getAndDecodeOption("hide_navigation", location.href) === "true" ||
      getAndDecodeOption("device", location.href) === "ios" ||
      getAndDecodeOption("device", location.href) === "android",
    device: getAndDecodeOption("device", location.href),
  };
}
